import React, { useEffect, useState } from "react";
import { Table, } from "antd";
import styles from "./HelpSupport.module.css";
import { Modal, TextComponent } from "../../components";
import { PagesMiddleware } from "../../Store/Middlewares/PagesMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Pagination from "../../components/Pagination/Pagination";
import { AiOutlineCloseCircle } from "react-icons/ai";


const HelpSupport = () => {

  const SUPPORT_QUERIES = useSelector(state => state.PagesReducer.queries);
  const SUPPORT_QUERIES_PAGINATION = useSelector(state => state.PagesReducer.queriesPagination);

  const [currentPage, setCurrentPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(12);
  const dispatch = useDispatch()
  const [viewQueryModal, setViewQueryModal] = useState(false);
  const [queryData, setQueryData] = useState(null);

  useEffect(() => {
    getData()
  }, []);

  const getData = (arg) => {
    const data = {
      limit: pageLimit,
      page: 1,
    };
    dispatch(PagesMiddleware.getQueries(arg || data))
      .then((res) => { })
      .catch((err) => { console.log("error", err) });
  }

  const onDelQuery = (record) => {
    dispatch(PagesMiddleware.delQuery({ id: record.id }))
      .then((res) => { })
      .catch((err) => { console.log("error", err) });
  }



  const columns = [
     {
      title: "S.No",
      dataIndex: "id",
      key: "S.No",
      render: (text, record, index) => {
        return (
          <TextComponent
            text={index + 1}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "User Name",
      dataIndex: "lastName",
      key: "User Name",
      render: (text, record) => (
        <TextComponent
          text={(record?.firstName || "--") + " " + ( record?.lastName || "--")}
          style={{ color: "black" }}
        />
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "Title",
    },
    {
      title: "Query",
      dataIndex: "description",
      key: "Query",
      render: (text) => (
        <TextComponent
          text={text}
          style={{ color: "black" , maxWidth: "110px", whiteSpace: "nowrap", elipse: "...", overflow: "hidden", textOverflow: "ellipsis" }}
        />
      ),
    },
    {
      title: "Submitted On",
      dataIndex: "createdAt",
      key: "Submitted On",
      render: (text) => (
        <TextComponent
          text={moment(text).format("MMM, DD, YYYY")}
          style={{ color: "black" }}
        />
      ),
    },
     {
      title: "",
      key: "button",
      render: (record) => (
        <button onClick={() =>{
         setQueryData(record);
         setViewQueryModal(true);
        }
        }
         className={styles.TableButton}>View</button>
      ),
    },
    {
      title: "",
      key: "button",
      render: (record) => (
        <button onClick={() => onDelQuery(record)} className={styles.TableButtonx}>Delete</button>
      ),
    },
  ];

  return (
    <div className={styles.mainCont}>

      <div className={styles.HeadingDiv}>
        <TextComponent
          className={styles.Heading}
          text={"Support Queries"}
        />
      </div>


      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={SUPPORT_QUERIES}
          pagination={false}
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
          }}
        />

        {

          (SUPPORT_QUERIES_PAGINATION?.totalPages > 1) &&
          <Pagination
            currentPage={currentPage}
            totalPages={SUPPORT_QUERIES_PAGINATION?.totalPages}
            nextButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage + 1,
              });
              setCurrentPage(currentPage + 1);
            }}
            previousButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage - 1,
              });
              setCurrentPage(currentPage - 1);
            }}
          />
        }

      </div>

      <Modal
        footer={null} 
        closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
        open={viewQueryModal}
        onCancel={() => setViewQueryModal(false)}
      >
        <div className={styles.modal}>
          <TextComponent text="Query Details" className={styles.modalheading} />

          <div className={styles.queryDetail}>
            <p><strong>Title:</strong> {queryData?.title}</p>
            <p><strong>Username:</strong> {queryData?.firstName + " " + queryData?.lastName}</p>
            <p><strong>Query:</strong></p>
            <div className={styles.queryText}>
              {queryData?.description}
            </div>
          </div>
        </div>
      </Modal>




    </div>
  );
};

export default HelpSupport;
